import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from '@shared/components/alert/alert.component';

import { DarkModeService } from '@core/services/dark-mode.service';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ModalConfirmComponent } from '@shared/components/modal-confirm/modal-confirm.component';
import { OfflineBootstrapService } from '@core/services/offline-bootstrap.service';
import { PullToRefreshService } from '@core/services/pull-to-refresh.service';
import { LoadingComponent } from '@shared/loading/loading.component';
import { GlobalLoadingService } from '@core/services/global-loading.service';

@Component({
    selector: 'app-root',
    imports: [
    RouterOutlet,
    AlertComponent,
    ModalComponent,
    ModalConfirmComponent,
    LoadingComponent
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  private readonly darkModeService = inject(DarkModeService);
  private readonly offlineBootstrapService = inject(OfflineBootstrapService);
  readonly globalLoadingService = inject(GlobalLoadingService);
  readonly pullToRefreshService = inject(PullToRefreshService);

  constructor() {
    try {
      this.offlineBootstrapService.init();
    } catch (error) {
      console.warn('No fue posible iniciar el modo offline:', error);
    }

    try {
      this.pullToRefreshService.init();
    } catch (error) {
      console.warn('No fue posible iniciar pull-to-refresh:', error);
    }

    effect(() => {
      if (this.darkModeService.darkMode()) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    });
  }
}
